import { render, staticRenderFns } from "./addGoonsAnnouncement.vue?vue&type=template&id=6ae68927&scoped=true&"
import script from "./addGoonsAnnouncement.vue?vue&type=script&lang=ts&"
export * from "./addGoonsAnnouncement.vue?vue&type=script&lang=ts&"
import style0 from "./addGoonsAnnouncement.vue?vue&type=style&index=0&id=6ae68927&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae68927",
  null
  
)

export default component.exports